/* eslint-disable no-unused-vars */
import { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { creativesActions, trackingActions } from 'store/actions';
import { showActionsCreative } from 'utils';
import { getActiveCreativesList } from 'store/selectors';
//change current tracking

export const useFacade = (environment) => {
  const dispatch = useDispatch();
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );
  const selectedCreative = useSelector((state) => state?.creatives?.selectedCreative);
  const activeCreativesList = useSelector(getActiveCreativesList);
  const isCustomTracking = useSelector((state) => state?.tracking?.isCustomTracking);

  const isHiddenFlag = useMemo(() => {
    return showActionsCreative(environment, isCustomTracking, activeCreativesList);
  }, [isCustomTracking, environment, activeCreativesList]);

  const selectedTracking = useMemo(() => {
    const currentTracking = creativesTracking?.find(
      (trackItem) => trackItem?.bn_bannerid === selectedCreative?.bn_bannerid,
    );
    return currentTracking;
  }, [selectedCreative?.bn_bannerid, creativesTracking]);

  const handleChange = useCallback(
    (checked) => {
      const baseTracking = selectedTracking || creativesTracking?.[0];
      if (!checked) {
        const fieldsToSync = [
          'Deep_Link',
          'Tracking_Link',
          'Impression_Link',
          'VTA_Link',
          'tracking_company',
        ];
        // clear all tracking links to be ''
        fieldsToSync.forEach((field) => {
          dispatch(
            creativesActions.updateAllTrackings({
              propField: field,
              newValue: baseTracking?.[field] ?? '',
            }),
          );
        });
      }
      dispatch(trackingActions.changeIsCustomTracking(checked));
    },
    [dispatch, selectedTracking, creativesTracking],
  );

  const linkUpdateAction = useCallback((newUrl, field, bn_bannerid) => {
    dispatch(
      creativesActions.updateOneFieldCurrentTracking({
        propField: field,
        newValue: newUrl,
        idToUpdate: bn_bannerid,
      }),
    );
  }, []);

  const update_one_tc_number = (tc_number, bn_bannerid) => {
    dispatch(
      creativesActions.updateOneFieldCurrentTracking({
        propField: 'tracking_company',
        newValue: tc_number,
        idToUpdate: bn_bannerid,
      }),
    );
  };

  return {
    selectedCreative,
    selectedTracking,
    handleChange,
    linkUpdateAction,
    isCustomTracking,
    isHiddenFlag,
    update_one_tc_number,
  };
};
